import {
    ORDER_HISTORY_RESPONSE, ORDER_HISTORY_RESPONSE_FAIL
} from "../types/orderbook";

const initialState = {
    orderHistory: []
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ORDER_HISTORY_RESPONSE:
            return { ...state, orderHistory: action.payload }
        case ORDER_HISTORY_RESPONSE_FAIL:
            return { ...state, orderHistory: action.payload }
        default:
            return state
    }
}
